import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { UserEntity } from './user.entity';

export type ListBulkActionStatus =
	| 'pending'
	| 'processing'
	| 'completed'
	| 'failed';

@Index('idx_list_bulk_action_user_list', ['userId', 'listKey'])
@Index('idx_list_bulk_action_list_key', ['listKey'])
@Index('idx_list_bulk_action_status', ['status'])
@Index('idx_list_bulk_action_created', ['createdDate'])
@Entity('list_bulk_action')
export class ListBulkActionEntity extends BaseEntity {
	@Column('varchar', { name: '_list_key', length: 100 })
	public listKey!: string;

	@Column('varchar', { name: '_action_type', length: 100 })
	public actionType!: string;

	@Column('int', { name: '_fk_user__id', unsigned: true, nullable: true })
	public userId!: number | null;

	@ManyToOne(() => UserEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_user__id', referencedColumnName: 'id' }])
	public user!: UserEntity | null;

	@Column('int', { name: '_target_list_id', unsigned: true, nullable: true })
	public targetListId!: number | null;

	@Column('enum', {
		name: '_status',
		enum: ['pending', 'processing', 'completed', 'failed'],
		default: 'pending',
	})
	public status!: ListBulkActionStatus;

	@Column('int', { name: '_total_count', unsigned: true, default: 0 })
	public totalCount!: number;

	@Column('int', { name: '_completed_count', unsigned: true, default: 0 })
	public completedCount!: number;

	@Column('int', { name: '_failed_count', unsigned: true, default: 0 })
	public failedCount!: number;

	@Column('datetime', { name: '_started_at', nullable: true })
	public startedAt!: Date | null;

	@Column('datetime', { name: '_completed_at', nullable: true })
	public completedAt!: Date | null;

	@Column('text', { name: '_error_message', nullable: true })
	public errorMessage!: string | null;
}
